import { useCallback } from 'react';
import { AsyncThunkAction } from '@reduxjs/toolkit';

import { useAppDispatch } from './useAppDispatch';

/**
 * Hooks for dispatching asynchronous thunk actions and allow unwrapping (get response payload or error) directly
 * Read : https://github.com/reduxjs/redux-toolkit/issues/775
 *  And : https://stackoverflow.com/questions/68812319/redux-toolkit-argument-of-type-asyncthunkaction-is-not-assignable-to-param
 */
export const useThunkDispatch = () => {
  const dispatch = useAppDispatch();

  return useCallback(
    <R>(asyncThunk: AsyncThunkAction<R, any, any>): Promise<R> => {
      // @ts-ignore
      return dispatch(asyncThunk).unwrap();
    },
    [dispatch],
  );
};
